export const renderAccordionContent = () => {
    return (
        <>
            <strong>Логическое «И» — это когда все условия должны выполниться одновременно. Это как будто мы сужаем круг, находя только тех, кто попал в пересечение двух групп.</strong>
            <ul>
                <li>Пример: «Устройство = Mobile» И «OC = iOS».</li>
                <li>Результат: Только узкая группа — пользователи именно мобильных iOS-устройств.</li>
            </ul>
            <strong>Логическое «ИЛИ» — это когда достаточно выполнения любого из условий. Это как будто мы объединяем две группы в одну большую.</strong>
            <ul>
                <li>Пример: «Устройство = Mobile» И «OC = iOS ИЛИ Android».</li>
                <li>Результат: Все мобильные пользователи, независимо от того, какая у них OC (iOS или Android).</li>
            </ul>
            <strong>Операторы = (равно) и ≠ (не равно) — это два способа отбора пользователей внутри условия: = (Равно) — это включение в группу. Вы говорите: &quot;Хочу видеть именно этих&quot;.</strong>
            <ul>
                <li>Пример: «OC = iOS»</li>
                <li>Результат: Только пользователи с iOS.</li>
            </ul>
            <strong>≠ (Не равно) — это исключение из группы. Вы говорите: «Хочу видеть всех, кроме этих».</strong>
            <ul>
                <li>Пример: «OC ≠ iOS»</li>
                <li>Результат: Все пользователи, у которых нет iOS (т.е. Android, Windows и т.д.).</li>
            </ul>
        </>
    );
};

export const pageTitles = {
    main: "CMS RIS PROMO",
    companies: "CMS offers",
    offers: "CMS vendor",
    projects: "CMS vitrina",
    "not-found": "CMS not found",
    "buckets-add": "CMS buckets add",
    "buckets-get": "CMS buckets get",
    "test-offer": "CMS AB offer",
    "replace-data": "CMS replace data",
    "test-site": "CMS test site",
    sort: "CMS sort",
    activate: "CMS activate",
    "uploaded-activations": "CMS activate uploaded",
    "unload-promo": "CMS unload promo",
    "unload-leads": "CMS unload leads",
    "unload-total": "CMS unload total",
    "position-calculator": "CMS position calculator",
    ranging: "Ranging",
    lego: "CMS Lego",
};
